import { PERMISSIONS_URL } from "../common/constants"
import { deepHexlify, UserOperation, resolveProperties } from "../common"
import { validateUserOp } from "../base/UserOpHandler"

export const signUserOpWithSessionKey = async (
    accountAddress: string,
    chainId: number,
    apiKey: string,
    sessionKey: string,
    userOp: UserOperation,
    permissionsBackendUrl: string = PERMISSIONS_URL
): Promise<UserOperation> => {
    let response = null;

    try {

        if(!sessionKey) {
            throw new Error('Session key is required')
        }

        if(!apiKey) {
            throw new Error('API key is required')
        }

        if(!accountAddress) {
            throw new Error('Account address is required')
        }

        if(chainId === undefined || chainId === null || chainId <= 0) {
            throw new Error('Chain ID is required')
        }

        validateUserOp(userOp);

        let url = `${permissionsBackendUrl}/account/signUserOp?account=${accountAddress}&chainId=${chainId}&sessionKey=${sessionKey}&apiKey=${apiKey}`;

        response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(deepHexlify(await resolveProperties(userOp))),
        });

        if (response.status === 200) {
            const responseJson = await response.json();
            return responseJson
        } else {
            const responseJson = await response.json();
            throw new Error(responseJson.message)
        }
    } catch (err) {
        throw new Error(err.message)
    }
}
